<p class="clickable-cell" (click)="clickAction(row)">{{value}}</p>